(function () {
"use strict";
const $ = (s, r) => (r || document).querySelector(s);
const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
const clamp = (v, a, b) => Math.min(b === undefined ? 1 : b, Math.max(a === undefined ? 0 : a, v));
const root = document.documentElement;
const RM = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
const HAS_IO = "IntersectionObserver" in window;
if (HAS_IO) root.classList.add("anim");
const TT = window.IA_T || {};
const t = (k) => TT[k] || k;
const lang = (root.lang || "es").split("-")[0].toLowerCase();
const LOC = { es: "es-AR", en: "en-US", pt: "pt-BR", fr: "fr-FR", de: "de-DE", it: "it-IT", nl: "nl-NL", pl: "pl-PL", tr: "tr-TR", ru: "ru-RU", uk: "uk-UA", ja: "ja-JP", ko: "ko-KR", th: "th-TH", vi: "vi-VN", id: "id-ID", ar: "ar-AE", he: "he-IL" };
const CFG = (function () { try { return JSON.parse($("#ia-cfg").textContent); } catch (e) { return {}; } })();
const CUR = CFG.cur || "USD";
const fmt = (n, cur) => {
try { return new Intl.NumberFormat(LOC[lang] || lang, { style: "currency", currency: cur || CUR }).format(n); }
catch (e) { return (cur || CUR) + " " + n.toFixed(2); }
};
const CL = {};
"ADes|AEar|AFen|AGen|AIen|ALen|AMen|AOpt|ARes|ATde|AUen|AWnl|AXen|AZen|BAen|BBen|BDen|BEnl|BFfr|BGen|BHar|BIfr|BJfr|BLfr|BMen|BNen|BOes|BQnl|BRpt|BSen|BTen|BWen|BYru|BZen|CAen|CCen|CDfr|CFfr|CGfr|CHde|CIfr|CKen|CLes|CMfr|CNen|COes|CRes|CVpt|CWnl|CXen|CYen|CZen|DEde|DJfr|DKen|DMen|DOes|DZar|ECes|EEen|EGar|EHar|ERen|ESes|ETen|FIen|FJen|FKen|FOen|FRfr|GAfr|GBen|GDen|GEen|GFfr|GGen|GHen|GIen|GLen|GMen|GNfr|GPfr|GQes|GRen|GTes|GWpt|GYen|HKen|HNes|HRen|HTfr|HUen|IDid|IEen|ILhe|IMen|INen|IOen|IQar|ISen|ITit|JEen|JMen|JOar|JPja|KEen|KGru|KHen|KIen|KMfr|KNen|KRko|KWar|KYen|KZru|LAen|LBar|LCen|LIde|LKen|LRen|LSen|LTen|LUfr|LVen|LYar|MAar|MCfr|MDen|MEen|MFfr|MGfr|MKen|MLfr|MMen|MNen|MOen|MQfr|MRar|MSen|MTen|MUen|MVen|MWen|MXes|MYen|MZpt|NAen|NCfr|NEfr|NFen|NGen|NIes|NLnl|NOen|NPen|NRen|NUen|NZen|OMar|PAes|PEes|PFfr|PGen|PHen|PKen|PLpl|PMfr|PNen|PSar|PTpt|PYes|QAar|REfr|ROen|RSen|RUru|RWen|SAar|SBen|SCen|SDar|SEen|SGen|SHen|SIen|SJen|SKen|SLen|SMit|SNfr|SOen|SRnl|SSen|STpt|SVes|SXnl|SZen|TCen|TDfr|TGfr|THth|TJru|TKen|TLpt|TMru|TNar|TOen|TRtr|TTen|TVen|TWen|TZen|UAuk|UGen|USen|UYes|UZru|VAit|VCen|VEes|VGen|VNvi|VUen|WFfr|WSen|XKen|YEar|YTfr|ZAen|ZMen|ZWen".split("|").forEach((x) => { CL[x.slice(0, 2)] = x.slice(2); });
const compactMQ = window.matchMedia("(max-width:520px)");
const toastEl = $("#toast"); let toastTimer = 0;
function toast(msg) { if (!toastEl) return; toastEl.textContent = msg; toastEl.classList.add("on"); clearTimeout(toastTimer); toastTimer = setTimeout(() => toastEl.classList.remove("on"), 2800); }
window.IA = { t: t, usd: (n) => fmt(n), fmt: fmt, lang: () => lang, loc: () => LOC[lang] || lang, cur: CUR, RM: RM, HAS_IO: HAS_IO, toast: toast, reveal: () => {}, cfg: CFG };
const lf = $("#iaLoc"), selC = $("#country"), selL = $("#lang");
const country = selC ? selC.value : "AR";
let langManual = false;
try { langManual = localStorage.getItem("ia-lang-manual") === "1"; } catch (e) {}
function locSubmit(c, l) {
if (!lf) return;
if (c && lf.elements.country_code) lf.elements.country_code.value = c;
if (l && lf.elements.language_code) lf.elements.language_code.value = l;
lf.submit();
}
const langFor = (l) => { if (!selL || !l) return null; const o = Array.from(selL.options).find((x) => x.value.split("-")[0] === l); return o ? o.value : null; };
function setLang(l) {
try { localStorage.setItem("ia-lang-manual", "1"); localStorage.setItem("ia-lang", l); } catch (e) {}
locSubmit(null, l);
}
function setCountry(c) {
let l = null;
if (!langManual) { const dl = langFor(CL[c]); if (dl && dl.split("-")[0] !== lang) l = dl; }
try { localStorage.setItem("ia-country", c); } catch (e) {}
if (c === country && !l) return;
locSubmit(c, l);
}
const cname = (c) => { try { return new Intl.DisplayNames([LOC[lang] || lang], { type: "region" }).of(c); } catch (e) { return c; } };
if (selC) selC.addEventListener("change", (e) => setCountry(e.target.value));
if (selL) selL.addEventListener("change", (e) => setLang(e.target.value));
function compactSel() {
const cp = compactMQ.matches;
[selC, selL].forEach((s) => {
if (!s) return;
Array.from(s.options).forEach((o) => { if (o._n === undefined) o._n = o.textContent; o.textContent = cp ? (s === selL ? o.value.split("-")[0].toUpperCase() : o.value) : o._n; });
});
}
function applyI18n() {
if (lang !== "es") {
$$("[data-i18n]").forEach((el) => { const v = TT[el.dataset.i18n]; if (v) el.textContent = v; });
$$("[data-ia]").forEach((el) => { const v = TT[el.dataset.ia]; if (v) el.setAttribute("aria-label", v); });
}
compactSel();
root.classList.add("ia-ok");
}
if (compactMQ.addEventListener) compactMQ.addEventListener("change", compactSel);
applyI18n();
const L = $("#lcLang");
if (L && selL) {
L.innerHTML = Array.from(selL.options).map((o) => '<button type="button" data-l="' + o.value + '" lang="' + o.value + '" aria-pressed="' + (o.value === selL.value) + '"><span>' + (o._n || o.textContent) + "</span></button>").join("");
L.addEventListener("click", (e) => { const b = e.target.closest("button[data-l]"); if (b && b.dataset.l !== selL.value) setLang(b.dataset.l); });
}
const GATE = {
es: { t: "¿Desde dónde comprás?", d: "Elegí tu país: los precios y el cobro son en dólares (USD).", s: "Buscar país…", c: "Continuar con", n: "Sin resultados", x: "Cerrar" },
en: { t: "Where are you shopping from?", d: "Pick your country: prices and payment are in US dollars (USD).", s: "Search country…", c: "Continue with", n: "No results", x: "Close" },
pt: { t: "De onde você está comprando?", d: "Escolha seu país: os preços e a cobrança são em dólares (USD).", s: "Buscar país…", c: "Continuar com", n: "Sem resultados", x: "Fechar" }
};
const gt = (k) => (GATE[lang] || GATE.en)[k];
const flagE = (c) => (/^[A-Z]{2}$/.test(c) ? String.fromCodePoint.apply(null, c.split("").map((x) => 127397 + x.charCodeAt(0))) : "🌐");
let pick = country;
function gateClose() { const g = $("#gate"); if (g) g.remove(); try { localStorage.setItem("ia-gate", "1"); } catch (e) {} document.removeEventListener("keydown", gateKey); }
function gateKey(e) { if (e.key === "Escape") gateClose(); }
function gateList(q) {
if (!selC) return;
const qq = (q || "").trim().toLowerCase();
let list = Array.from(selC.options).map((o) => ({ c: o.value, n: o._n || o.textContent }));
if (qq) list = list.filter((o) => o.n.toLowerCase().indexOf(qq) >= 0 || o.c.toLowerCase() === qq);
$("#gateL").innerHTML = list.length ? list.map((o) => '<li><button type="button" data-gc="' + o.c + '"' + (o.c === country ? ' aria-current="true"' : "") + '><span class="gf">' + flagE(o.c) + '</span><span class="gn">' + o.n + '</span><span class="gcur">' + CUR + "</span></button></li>").join("") : '<li class="gnone">' + gt("n") + "</li>";
}
function gateOpen(force) {
let done = false; try { done = localStorage.getItem("ia-gate") === "1"; } catch (e) {}
if ((done && !force) || $("#gate") || !selC) return;
if (!done) {
const nl = (navigator.languages && navigator.languages[0]) || navigator.language || "", m = /[-_]([A-Za-z]{2})$/.exec(nl);
if (m && Array.from(selC.options).some((o) => o.value === m[1].toUpperCase())) pick = m[1].toUpperCase();
}
const nm = (c) => { const o = Array.from(selC.options).find((x) => x.value === c); return o ? (o._n || o.textContent) : cname(c); };
const el = document.createElement("div");
el.id = "gate"; el.className = "gate"; el.setAttribute("role", "dialog"); el.setAttribute("aria-modal", "true"); el.setAttribute("aria-labelledby", "gateT");
el.innerHTML = '<div class="gbox"><button type="button" class="gx" id="gateX" aria-label="' + gt("x") + '">×</button><h2 id="gateT">' + gt("t") + "</h2><p>" + gt("d") + '</p><button type="button" class="btn gcont" id="gateC">' + gt("c") + " " + flagE(pick) + " " + nm(pick) + '</button><input id="gateQ" type="search" autocomplete="off" placeholder="' + gt("s") + '" aria-label="' + gt("s") + '"><ul id="gateL"></ul></div>';
document.body.appendChild(el);
gateList("");
$("#gateQ").addEventListener("input", (e) => gateList(e.target.value));
$("#gateC").addEventListener("click", () => { gateClose(); if (pick !== country) setCountry(pick); });
$("#gateX").addEventListener("click", gateClose);
$("#gateL").addEventListener("click", (e) => { const b = e.target.closest("button[data-gc]"); if (!b) return; gateClose(); setCountry(b.dataset.gc); });
document.addEventListener("keydown", gateKey);
const cur = $("#gateL [aria-current]"); if (cur && cur.scrollIntoView) { try { cur.scrollIntoView({ block: "center" }); } catch (e) {} }
try { $("#gateC").focus({ preventScroll: true }); } catch (e) {}
}
window.IA.gate = gateOpen;
gateOpen();
function closeMenu() { const m = $("#mmenu"); if (m) { m.hidden = true; const b = $("#btnMenu"); if (b) b.setAttribute("aria-expanded", "false"); } }
window.IA.closeMenu = closeMenu;
document.addEventListener("click", (e) => {
const tg = e.target;
if (tg.closest && tg.closest("#btnMenu")) { const m = $("#mmenu"); m.hidden = !m.hidden; $("#btnMenu").setAttribute("aria-expanded", String(!m.hidden)); return; }
if (!tg.closest("#mmenu")) closeMenu();
});
document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeMenu(); });
if (!RM && window.matchMedia("(hover:hover)").matches) {
document.addEventListener("pointermove", (e) => {
const card = e.target.closest && e.target.closest(".card");
if (!card) return;
const in3d = $(".in3d", card), shine = $(".shine", card);
if (!in3d) return;
const r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
in3d.style.transform = "rotateY(" + ((x - 0.5) * 14).toFixed(2) + "deg) rotateX(" + ((0.5 - y) * 14).toFixed(2) + "deg)";
shine.style.setProperty("--gx", (x * 100).toFixed(1) + "%"); shine.style.setProperty("--gy", (y * 100).toFixed(1) + "%");
});
document.addEventListener("pointerout", (e) => {
const card = e.target.closest && e.target.closest(".card");
if (card && !card.contains(e.relatedTarget)) { const in3d = $(".in3d", card); if (in3d) in3d.style.transform = ""; }
});
}
if (HAS_IO) {
const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } }), { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
$$(".rv").forEach((el) => io.observe(el));
window.IA.reveal = (els) => els.forEach((el) => io.observe(el));
const route = $("#route");
if (route) { const io2 = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { route.style.setProperty("--w", "100%"); io2.disconnect(); } }), { threshold: 0.5 }); io2.observe(route); }
} else $$(".rv").forEach((el) => el.classList.add("in"));
const hdr = $("#hdr"), progress = $("#progress"), sticky = $("#sticky");
let heroH = 1, hero = null, medalScrollFn = null, onceFn = null;
function onScroll() {
const sy = window.scrollY || window.pageYOffset;
if (hdr) hdr.classList.toggle("solid", sy > 40);
const max = root.scrollHeight - window.innerHeight;
if (progress) progress.style.setProperty("--sp", (max > 0 ? clamp(sy / max) : 0).toFixed(4));
if (sticky) sticky.classList.toggle("on", sy > heroH * 0.6);
if (medalScrollFn) medalScrollFn(sy);
if (onceFn) onceFn();
}
window.addEventListener("scroll", onScroll, { passive: true });
onScroll();
hero = $("#inicio");
if (!hero) return;
const pin = $("#pin"), tilt = $("#tilt"), glow = $("#glow");
const ease = (x) => (x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2);
let canvas = $("#flag"), ctx = null, gl = null, useGL = false;
const TW = 1792, TH = 1152;
let tex = null;
function makeTex() {
const c = document.createElement("canvas"); c.width = TW; c.height = TH;
const g = c.getContext("2d"), bh = TH / 3;
[0, 2 * bh].forEach((y) => {
const gr = g.createLinearGradient(0, y, 0, y + bh);
gr.addColorStop(0, "#A6CCF4"); gr.addColorStop(0.5, "#80B3E8"); gr.addColorStop(1, "#6498D6");
g.fillStyle = gr; g.fillRect(0, y, TW, bh);
});
const gw = g.createLinearGradient(0, bh, 0, 2 * bh);
gw.addColorStop(0, "#FFFFFF"); gw.addColorStop(0.5, "#F7FAFF"); gw.addColorStop(1, "#E2EBF7");
g.fillStyle = gw; g.fillRect(0, bh, TW, bh);
g.globalAlpha = 0.03; g.strokeStyle = "#0A2A66"; g.lineWidth = 1; g.beginPath();
for (let d = -TH; d < TW; d += 7) { g.moveTo(d, 0); g.lineTo(d + TH, TH); }
g.stroke(); g.globalAlpha = 1;
[bh, 2 * bh].forEach((y) => { const s = g.createLinearGradient(0, y - 6, 0, y + 6); s.addColorStop(0, "rgba(0,30,90,0)"); s.addColorStop(0.5, "rgba(0,30,90,.18)"); s.addColorStop(1, "rgba(0,30,90,0)"); g.fillStyle = s; g.fillRect(0, y - 6, TW, 12); });
const vg = g.createRadialGradient(TW / 2, TH / 2, TH * 0.3, TW / 2, TH / 2, TW * 0.7);
vg.addColorStop(0, "rgba(0,10,40,0)"); vg.addColorStop(1, "rgba(0,10,40,.3)");
g.fillStyle = vg; g.fillRect(0, 0, TW, TH);
return c;
}
const LIGHT = [], DARK = [];
for (let k = 0; k <= 32; k++) { LIGHT.push("rgba(255,255,255," + (k / 32 * 0.24).toFixed(3) + ")"); DARK.push("rgba(0,16,56," + (k / 32 * 0.42).toFixed(3) + ")"); }
const dust = [];
for (let i = 0; i < 70; i++) dust.push({ x: Math.random(), y: Math.random(), r: 0.6 + Math.random() * 1.8, s: 0.015 + Math.random() * 0.04, ph: Math.random() * 6.28, a: 0.25 + Math.random() * 0.6 });
let cw = 0, ch = 0, dpr = 1, offs = new Float32Array(0);
let ps = 0, q = 1, slow = 0, dprScale = 1;
let tx = 0, ty = 0, cx = 0, cy = 0, gx = 0, gy = 0, gtx = 0, gty = 0, tiltRaf = 0;
let heroIn = true, running = false, stopped = false, raf = 0, t0 = 0, lastDraw = 0, pending = false, probed = false;
let medal = null, giveUp = 0;
const emblem = $("#emblem"), mcv = $("#medal"), stage = $("#stage3d");
const isMobile = () => root.clientWidth <= 860;
function freshCanvas() { const c = canvas.cloneNode(false); canvas.replaceWith(c); canvas = c; }
function useCanvas2D() {
useGL = false; gl = null;
ctx = canvas.getContext("2d");
if (!ctx) { freshCanvas(); ctx = canvas.getContext("2d"); }
}
function onLost(e) { e.preventDefault(); freshCanvas(); useCanvas2D(); measure(); }
try { gl = FlagGL.create(canvas); } catch (e) { gl = null; }
if (gl) { useGL = true; canvas.addEventListener("webglcontextlost", onLost, false); } else useCanvas2D();
function drawFlag(time) {
const W = cw, H = ch;
if (!W || !H) return;
if (!tex) tex = makeTex();
ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
ctx.globalCompositeOperation = "source-over";
ctx.fillStyle = "#0A1A44"; ctx.fillRect(0, 0, W, H);
const zoom = 1 + 0.12 * ps;
const portrait = W < H;
let fw = portrait ? W * 2.3 * zoom : Math.max(W * 1.15, H * 1.28 * 14 / 9) * zoom;
let fh = portrait ? H * 1.18 * zoom : fw * 9 / 14;
const x0 = (W - fw) / 2, y0 = (H - fh) / 2 - ps * H * 0.08;
const N = Math.max(120, Math.min(640, Math.round(W / 2.4 * q)));
if (offs.length !== N + 1) offs = new Float32Array(N + 1);
const base = portrait ? W * 0.095 : Math.min(W, H) * 0.062, dw = fw / N, sw = TW / N;
const k1 = 2.1 + (W > 900 ? 0 : 0.5);
for (let i = 0; i <= N; i++) {
const u = i / N, a = base * (0.42 + 0.58 * u);
const ph = u * k1 * 6.2832 - time * 1.55;
offs[i] = Math.sin(ph) * a + Math.sin(ph * 2.13 + time * 0.62) * a * 0.27 + Math.sin(u * 3.1 - time * 0.41) * a * 0.42;
}
for (let i = 0; i < N; i++) {
const slope = (offs[i + 1] - offs[i]) / dw;
const l = clamp(slope * (portrait ? 1.5 : 2.5), -1, 1);
const sh = fh * (1 - 0.055 * Math.abs(l));
const xa = Math.round((x0 + i * dw) * dpr) / dpr, xb = Math.round((x0 + (i + 1) * dw) * dpr) / dpr;
const sa = Math.round(i * sw), sb = Math.round((i + 1) * sw);
ctx.setTransform(dpr, dpr * slope, 0, dpr, dpr * xa, dpr * (y0 + offs[i] + (fh - sh) / 2));
ctx.drawImage(tex, sa, 0, Math.max(1, sb - sa), TH, 0, 0, xb - xa + 1 / dpr, sh);
const qq = Math.round(Math.abs(l) * 32);
if (qq > 0) { ctx.fillStyle = l > 0 ? LIGHT[qq] : DARK[qq]; ctx.fillRect(0, 0, xb - xa + 1 / dpr, sh); }
}
ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
if (q >= 0.7) {
ctx.globalCompositeOperation = "soft-light";
const sx = ((time * 0.045) % 1.6 - 0.3) * W;
const grad = ctx.createLinearGradient(sx - W * 0.35, 0, sx + W * 0.35, H * 0.4);
grad.addColorStop(0, "rgba(255,255,255,0)"); grad.addColorStop(0.5, "rgba(255,255,255,.55)"); grad.addColorStop(1, "rgba(255,255,255,0)");
ctx.fillStyle = grad; ctx.fillRect(0, 0, W, H);
}
ctx.globalCompositeOperation = "lighter";
for (let i = 0; i < dust.length; i++) {
const d = dust[i];
const x = ((d.x + time * d.s) % 1) * W, y = ((d.y - time * d.s * 0.55) % 1 + 1) % 1 * H + Math.sin(time * 0.8 + d.ph) * 10;
const tw = 0.55 + 0.45 * Math.sin(time * 1.4 + d.ph);
ctx.fillStyle = "rgba(255,217,122," + (d.a * tw * 0.18).toFixed(3) + ")"; ctx.beginPath(); ctx.arc(x, y, d.r * 3.2, 0, 6.2832); ctx.fill();
ctx.fillStyle = "rgba(255,226,150," + (d.a * tw).toFixed(3) + ")"; ctx.beginPath(); ctx.arc(x, y, d.r, 0, 6.2832); ctx.fill();
}
ctx.globalCompositeOperation = "source-over";
}
function sizeCanvas() {
if (useGL) {
const budget = root.clientWidth <= 860 ? 1.1e6 : 1.8e6;
dpr = Math.max(0.5, Math.min(Math.min(window.devicePixelRatio || 1, 2) * dprScale, Math.sqrt(budget / Math.max(1, cw * ch))));
gl.resize(cw, ch, dpr);
} else {
dpr = Math.min(window.devicePixelRatio || 1, 1.25);
canvas.width = Math.round(cw * dpr); canvas.height = Math.round(ch * dpr);
}
}
function probeGPU() {
try {
gl.resize(cw, ch, 0.3);
const g = gl.gl, px = new Uint8Array(4);
const sync = () => g.readPixels(0, 0, 1, 1, g.RGBA, g.UNSIGNED_BYTE, px);
gl.render(0, { p: 0 }); sync();
const a0 = performance.now();
gl.render(1, { p: 0 }); gl.render(2, { p: 0 }); sync();
return (performance.now() - a0) / 2 < 14;
} catch (e) { return true; }
}
function toStatic2D() {
try { if (gl && gl.destroy) gl.destroy(); } catch (e) {}
stopped = true; freshCanvas(); useCanvas2D(); measure();
}
function measure() {
if (!pin.clientWidth || !pin.clientHeight) return;
cw = pin.clientWidth; ch = pin.clientHeight; heroH = hero.offsetHeight || 1;
if (useGL && !probed) { probed = true; if (!probeGPU()) { toStatic2D(); return; } }
sizeCanvas();
sizeMedal();
medalMetrics();
if (stopped) drawBg(4);
}
function drawBg(time) {
const sy = window.scrollY || window.pageYOffset;
ps = clamp(sy / heroH) * 0.7;
if (useGL) gl.render(time, { p: ps, mx: cx, my: cy }); else drawFlag(time);
if (!canvas.classList.contains("on")) canvas.classList.add("on");
}
function tiltTick() {
cx += (tx - cx) * 0.1; cy += (ty - cy) * 0.1; gx += (gtx - gx) * 0.14; gy += (gty - gy) * 0.14;
tilt.style.transform = "rotateY(" + (cx * 15).toFixed(2) + "deg) rotateX(" + (-cy * 11).toFixed(2) + "deg)";
glow.style.transform = "translate3d(" + gx.toFixed(1) + "px," + gy.toFixed(1) + "px,0)";
tiltRaf = Math.abs(tx - cx) + Math.abs(ty - cy) + Math.abs(gtx - gx) + Math.abs(gty - gy) > 0.01 ? requestAnimationFrame(tiltTick) : 0;
}
function kick() { if (!tiltRaf && !RM) tiltRaf = requestAnimationFrame(tiltTick); }
pin.addEventListener("pointermove", (e) => {
if (e.pointerType === "touch") return;
const r = pin.getBoundingClientRect();
tx = ((e.clientX - r.left) / r.width) * 2 - 1; ty = ((e.clientY - r.top) / r.height) * 2 - 1;
gtx = e.clientX - r.left; gty = e.clientY - r.top;
kick();
if (medal) medal.setPointer(tx, ty);
});
pin.addEventListener("pointerleave", () => { tx = 0; ty = 0; kick(); if (medal) medal.setPointer(0, 0); });
function frame(now) {
raf = requestAnimationFrame(frame);
if (!t0) t0 = now;
if (now - lastDraw < 30) return;
if (lastDraw) { const dt = now - lastDraw; slow = dt > 52 ? slow + 1 : Math.max(0, slow - 1); if (slow > 24) { slow = 0; if (useGL) { if (dprScale > 0.56) { dprScale *= 0.8; sizeCanvas(); } else bail(); } else if (q > 0.4) q = Math.max(0.4, q * 0.75); else bail(); } }
lastDraw = now;
drawBg((now - t0) / 1000);
}
function bail() { toStatic2D(); sync(); }
function sync() {
if (medal) medal.setActive(heroIn && !document.hidden && !RM);
const should = heroIn && !document.hidden && !RM && !stopped;
if (should && !running) { running = true; raf = requestAnimationFrame(frame); }
if (!should && running) { running = false; cancelAnimationFrame(raf); lastDraw = 0; }
}
onceFn = function () {
if (!RM || pending) return;
pending = true;
requestAnimationFrame(() => { pending = false; drawBg(4); });
};
if (HAS_IO) new IntersectionObserver((es) => { heroIn = es[0].isIntersecting; sync(); }, { threshold: 0 }).observe(hero);
document.addEventListener("visibilitychange", sync);
let rzT = 0;
function onResize() { measure(); onScroll(); if (onceFn) onceFn(); if (!running) drawBg(RM ? 4 : 0); }
window.addEventListener("resize", () => { clearTimeout(rzT); rzT = setTimeout(onResize, 120); });
window.addEventListener("load", () => { measure(); onScroll(); });
let mSpan = 600, mDocBottom = 700, mLing = 0, mFade = 1, mApplied = false;
function medalMetrics() {
if (!emblem || !emblem.offsetWidth) return;
const sy = window.scrollY || window.pageYOffset;
const r = emblem.getBoundingClientRect();
mDocBottom = Math.max(240, r.bottom + sy - mLing);
mSpan = Math.max(260, Math.min(heroH * 0.85, mDocBottom * 0.9));
}
medalScrollFn = function (sy) {
if (!medal || !medal.ready || RM || !stage || !emblem.classList.contains("has3d")) {
if (mApplied) { stage.style.transform = ""; stage.style.opacity = ""; mApplied = false; mLing = 0; mFade = 1; }
return;
}
const p = clamp(sy / mSpan);
medal.setScroll(p);
const ling = isMobile() ? 0 : Math.min(sy, mSpan * 1.3) * 0.3;
const fade = 1 - clamp((sy / mSpan - 0.7) / 0.5);
if (Math.abs(ling - mLing) > 0.2 || (ling === 0 && mLing !== 0)) { mLing = ling; stage.style.transform = "translate3d(0," + ling.toFixed(1) + "px,0)"; }
if (Math.abs(fade - mFade) > 0.004 || (fade === 0 && mFade !== 0)) { mFade = fade; stage.style.opacity = fade >= 0.999 ? "" : fade.toFixed(3); }
mApplied = true;
};
function glOK() {
try {
const c = document.createElement("canvas"), g = c.getContext("webgl2") || c.getContext("webgl");
if (!g) return false;
const x = g.getExtension("WEBGL_lose_context"); if (x) x.loseContext();
return true;
} catch (e) { return false; }
}
function medalDrop() {
clearTimeout(giveUp);
emblem.classList.remove("wait3d", "has3d"); stage.classList.remove("can3d");
if (medal) { try { medal.dispose(); } catch (e) {} medal = null; }
stage.style.transform = ""; stage.style.opacity = ""; mApplied = false; mLing = 0; mFade = 1;
}
function sizeMedal() {
if (!medal) return;
const w = mcv.clientWidth, h = mcv.clientHeight;
if (!w || !h) return;
const budget = isMobile() ? 1.5e6 : 2.6e6;
medal.resize(w, h, Math.max(0.75, Math.min(window.devicePixelRatio || 1, 2, Math.sqrt(budget / (w * h)))));
}
function initMedal() {
if (!emblem || !mcv || !window.Medal || !window.THREE) { medalDrop(); return; }
let m = null;
try {
m = window.Medal.create(mcv, {
still: RM, mobile: isMobile(), adaptive: !window.__MEDAL_TEST,
onReady() {
clearTimeout(giveUp);
sizeMedal();
medal.setActive(heroIn && !document.hidden && !RM);
emblem.classList.remove("wait3d"); emblem.classList.add("has3d"); stage.classList.add("can3d");
medalMetrics(); medalScrollFn(window.scrollY || window.pageYOffset);
},
onFail() { medalDrop(); }
});
} catch (e) { m = null; }
if (!m) { medalDrop(); return; }
medal = m; window.__medal = m;
}
if (glOK()) {
emblem.classList.add("wait3d");
giveUp = setTimeout(medalDrop, 9000);
const go = () => requestAnimationFrame(initMedal);
if (window.THREE) go();
else if (window.__threeP) window.__threeP.then(go, medalDrop);
else medalDrop();
}
stage.addEventListener("click", (e) => {
if (!medal || !medal.ready) return;
const r = emblem.getBoundingClientRect();
if (Math.hypot(e.clientX - (r.left + r.width / 2), e.clientY - (r.top + r.height / 2)) < r.width * 0.56) medal.spin();
});
const tk = $("#tick"); if (tk) { const h = tk.innerHTML; tk.innerHTML = h + h + h + h; }
measure();
onScroll();
drawBg(0);
sync();
if (RM && onceFn) onceFn();
})();